import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services'
import CustomLoader from '../CustomLoader'
import { translate } from '../../utils/useful'
export default class ProjectsWidget extends Component {
    state = {

    }
    componentDidMount = () => {
        this.init()
    }
    init = () => {
        let data = { ...this.props.data }
        let body = { applet: data.applet, allApplets: data.allApplets }
        this.setState({ isLoading: true })

        HttpServices.request('getMyProjects', body, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.setState({ data: fetchResult.info }, () => {
                // console.log('datais', fetchResult.info)
            })
        })

    }
    changeProject = (item) => {
        if (this.props.functionsHandler) {
            this.props.functionsHandler('desk', 'changePage', [(item._id)])
        }
    }
    render() {
        return (
            <div className=" w-100 h-100 " >
                {this.state.isLoading ? (

                    <div className='h-100 w-100 flexcc'>
                        <CustomLoader isLoading={true} />
                    </div>
                ) : (
                    <div className='d-flex flex-column py-2'>
                        <p className='text-normal weight-700 main-c2 pb-3 px-2'>{translate('Projects')}</p>
                        <div className='flexc sc-gray-mx pb-3' style={{ overflowX: 'auto' }}>
                            {Array.isArray(this.state.data) && this.state.data.map((item, index) => {
                                return (
                                    <button className='flexcc flex-column mx-3' style={{ width: '70px' }} onClick={() => this.changeProject(item)}>
                                        <img className="transition br-20" src={'/assets/profile-def.png'} height={40} width={40} />
                                        <p className='text-small main-c2 pt-1 weight-600 w-100 flexcc' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name}</p>
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                )}

            </div>
        )
    }
}
